module.exports = __webpack_public_path__ + "templates/loyalty-list.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/loyalty/templates/loyalty-list.html
// module id = 6eE1
// module chunks = 1